import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c90288c")

_pushScopeId("data-v-3c90288c")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-mb-5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-mb-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    collapsed: true,
    header: _ctx.$t('legend'),
    toggleable: true
  }, {
    default: _withId(() => [
      _createVNode(_component_Card, null, {
        content: _withId(() => [
          (_ctx.legendInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('legendInfo')), 1),
                _hoisted_3,
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.legendInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("b", null, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('legendSubtitle')), 1)
                ]),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.legendItems, (item) => {
            return (_openBlock(), _createBlock("div", { key: item }, [
              _createVNode(_component_Button, {
                class: [item.styleClass, "formBox"]
              }, {
                default: _withId(() => [
                  _createVNode(_component_info_button),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
                ]),
                _: 2
              }, 1032, ["class"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["header"]))
})